var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #faab54;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.1,0c14,0,25,11,25,25s-11,25-25,25S.1,39,.1,25,11.1,0,25.1,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.4,21.4c.2.2.3.4.3.6s0,.5-.3.6l-7,6.7-1.3,1.3c-.2.2-.4.3-.7.3s-.5,0-.7-.3l-1.3-1.3-3.5-3.4c-.2-.2-.3-.4-.3-.6s0-.5.3-.6l1.3-1.3c.2-.2.4-.3.7-.3s.5,0,.7.3l2.8,2.7,6.3-6.1c.2-.2.4-.3.7-.3s.5,0,.7.3l1.3,1.3h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.1a903145f7d8c93491ea705af7ed967a.svg";
export { ForwardRef as ReactComponent };